import { useState } from "react";

function AffiliateHeroParallax() {
  const [mainImageLoaded, setMainImageLoaded] = useState(false);

  return (
    <div className="hero-man-parallax">
      <img
        src={`${process.env.PUBLIC_URL}/images/affiliate_hero.svg`}
        alt="Tax filing professional"
        className="hero-image-main"
        onLoad={() => setMainImageLoaded(true)}
      />
      {mainImageLoaded && (
        <>
          <img
            src={`${process.env.PUBLIC_URL}/images/affiliate_easy_start.svg`}
            alt="Process workflow"
            className="hero-image-complement hero-image-workflow"
            style={{ top: "50%", left: "0%" }}
          />
          <img
            src={`${process.env.PUBLIC_URL}/images/affiliate_earnings.svg`}
            alt="Tracking status"
            className="hero-image-complement hero-image-tracking"
          />
        </>
      )}
    </div>
  );
}

export default AffiliateHeroParallax;
